import React from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";

export default function Bitcoin(props) {
  return (
    <div className="new_design_page_area">
      <div className="container-md">
        <section className="new_design_banner_area">
          <div className="banner_image_section">
            <div className="banner_text_area">
              <br />
              <div className="title">
                {__("Play online casino")} <br /> {__("games with Bitcoin")}
              </div>
              <br />
              <div className="title heading">
                <svg
                  width="22"
                  height="23"
                  viewBox="0 0 22 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.1562 13.0161C20.3437 17.0786 17.2806 20.9038 12.9824 21.7586C10.8862 22.176 8.71163 21.9215 6.76844 21.0312C4.82525 20.1409 3.21248 18.6602 2.15977 16.8C1.10705 14.9398 0.668055 12.7949 0.905291 10.6707C1.14253 8.54644 2.0439 6.55121 3.48106 4.96907C6.42881 1.72232 11.4062 0.828565 15.4687 2.45357"
                    stroke="#4DE8FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.34375 11.3911L11.4062 15.4536L21.1562 4.89111"
                    stroke="#4DE8FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>{" "}
                {__("1st Deposit Bonus 100% up to 1 BTC")}
              </div>
              <br />
              <div className="title dsc">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.25 8.54741C12.75 11.0474 10.865 13.4014 8.21998 13.9274C6.92997 14.1843 5.59179 14.0277 4.39598 13.4798C3.20018 12.9319 2.2077 12.0207 1.55988 10.876C0.912049 9.73125 0.641899 8.4113 0.78789 7.10408C0.933882 5.79687 1.48857 4.56903 2.37298 3.59541C4.18698 1.59741 7.24998 1.04741 9.74998 2.04741"
                    stroke="#4DE8FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.75 7.54736L7.25 10.0474L13.25 3.54736"
                    stroke="#4DE8FF"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>{" "}
                {__("2nd Deposit Bonus 50% up to 0.5 BTC")}
              </div>
              <br />
              <br />
              <div className="row">
                <div className="col-lg-5">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="title dsc gray">
                        {" "}
                        <svg
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.25 8.54741C12.75 11.0474 10.865 13.4014 8.21998 13.9274C6.92997 14.1843 5.59179 14.0277 4.39598 13.4798C3.20018 12.9319 2.2077 12.0207 1.55988 10.876C0.912049 9.73125 0.641899 8.4113 0.78789 7.10408C0.933882 5.79687 1.48857 4.56903 2.37298 3.59541C4.18698 1.59741 7.24998 1.04741 9.74998 2.04741"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.75 7.54736L7.25 10.0474L13.25 3.54736"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        {__("Weekly Cashback")}
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="title dsc gray">
                        {" "}
                        <svg
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.25 8.54741C12.75 11.0474 10.865 13.4014 8.21998 13.9274C6.92997 14.1843 5.59179 14.0277 4.39598 13.4798C3.20018 12.9319 2.2077 12.0207 1.55988 10.876C0.912049 9.73125 0.641899 8.4113 0.78789 7.10408C0.933882 5.79687 1.48857 4.56903 2.37298 3.59541C4.18698 1.59741 7.24998 1.04741 9.74998 2.04741"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.75 7.54736L7.25 10.0474L13.25 3.54736"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        {__("8 Cryptocurrencies currently accepted")}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="title dsc gray">
                        {" "}
                        <svg
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.25 8.54741C12.75 11.0474 10.865 13.4014 8.21998 13.9274C6.92997 14.1843 5.59179 14.0277 4.39598 13.4798C3.20018 12.9319 2.2077 12.0207 1.55988 10.876C0.912049 9.73125 0.641899 8.4113 0.78789 7.10408C0.933882 5.79687 1.48857 4.56903 2.37298 3.59541C4.18698 1.59741 7.24998 1.04741 9.74998 2.04741"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.75 7.54736L7.25 10.0474L13.25 3.54736"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        {__("Regular Races")}
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="title dsc gray">
                        {" "}
                        <svg
                          width="14"
                          height="15"
                          viewBox="0 0 14 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.25 8.54741C12.75 11.0474 10.865 13.4014 8.21998 13.9274C6.92997 14.1843 5.59179 14.0277 4.39598 13.4798C3.20018 12.9319 2.2077 12.0207 1.55988 10.876C0.912049 9.73125 0.641899 8.4113 0.78789 7.10408C0.933882 5.79687 1.48857 4.56903 2.37298 3.59541C4.18698 1.59741 7.24998 1.04741 9.74998 2.04741"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.75 7.54736L7.25 10.0474L13.25 3.54736"
                            stroke="white"
                            stroke-opacity="0.9"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>{" "}
                        {__("VIP/Loyalty Scheme")}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div className="banner_links">
                <Link
                  className="app_btn"
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                >
                  {__("join now")}
                </Link>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
        </section>
      </div>
      <br />

      <section className="play_huge_section">
        <div className="container-md">
          <br />
          <div className="title">
            {__("Play a huge range of popular games, live casino and more...")}
          </div>
          <br />
          <br />
          <br />
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3">
              <div className="single_block">
                <div className="icon">
                  <svg
                    width="34"
                    height="35"
                    viewBox="0 0 34 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.689 10.6867C10.2418 10.6867 11.6095 10.2727 12.739 9.74452C11.5923 11.8515 10.9053 14.2904 10.7689 16.8056C6.18413 17.2862 2.589 21.0425 2.589 25.6455C2.589 30.5727 6.69352 34.6472 11.739 34.6472C13.2934 34.6472 14.7824 34.2195 16.1178 33.5041C14.0461 31.5208 12.7557 28.6958 12.7557 25.6455C12.7557 22.5951 14.0461 19.8363 16.1178 17.853C15.0895 17.302 13.969 16.9273 12.7991 16.7818C13.2412 9.76417 18.6682 3.97572 25.6655 2.91953C23.8834 5.36285 22.9223 8.27828 22.9223 11.3393V16.8102C18.3598 17.3116 14.789 21.058 14.789 25.6455C14.789 30.5727 18.8935 34.6472 23.939 34.6472C28.9845 34.6472 33.089 30.5727 33.089 25.6455C33.089 21.058 29.5182 17.3116 24.9557 16.8102V11.3393C24.9557 7.98249 26.294 4.82661 28.7245 2.45311L30.46 0.758301H28.0057C23.2305 0.758301 18.9028 2.65995 15.7715 5.72741C14.9494 4.95666 12.3135 2.74398 8.689 2.74398C4.39993 2.74398 1.4651 5.86496 1.32319 5.99785L0.555664 6.71533L1.32319 7.43281C1.4651 7.56571 4.39993 10.6867 8.689 10.6867ZM23.939 22.6669C22.2573 22.6669 20.889 24.0031 20.889 25.6455H18.8557C18.8557 22.9084 21.1363 20.6813 23.939 20.6813V22.6669ZM11.739 22.6669C10.0573 22.6669 8.689 24.0031 8.689 25.6455H6.65566C6.65566 22.9084 8.93628 20.6813 11.739 20.6813V22.6669Z"
                      fill="#10294F"
                    />
                  </svg>
                </div>
                <div className="title">{__("Casino")}</div>
                <div className="title dsc">
                  {__(
                    "Games from all the top providers with a huge range of slots, table games, video poker, live casino with new games added every week!"
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="single_block">
                <div className="icon">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 35 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M33.9576 12.6107H32.9494V11.6222C32.9494 11.0759 32.4985 10.6338 31.9413 10.6338C31.3841 10.6338 30.9332 11.0759 30.9332 11.6222V12.6107H29.9251C29.3679 12.6107 28.917 13.0528 28.917 13.5991C28.917 14.1455 29.3679 14.5875 29.9251 14.5875H30.9332V15.576C30.9332 16.1223 31.3841 16.5644 31.9413 16.5644C32.4985 16.5644 32.9494 16.1223 32.9494 15.576V14.5875H33.9576C34.5148 14.5875 34.9657 14.1455 34.9657 13.5991C34.9657 13.0528 34.5148 12.6107 33.9576 12.6107Z"
                      fill="#10294F"
                    />
                    <path
                      d="M29.858 8.65681C30.4147 8.65681 30.8661 8.21427 30.8661 7.66837C30.8661 7.12247 30.4147 6.67993 29.858 6.67993C29.3012 6.67993 28.8499 7.12247 28.8499 7.66837C28.8499 8.21427 29.3012 8.65681 29.858 8.65681Z"
                      fill="#10294F"
                    />
                    <path
                      d="M25.8255 14.5875C26.3823 14.5875 26.8336 14.1449 26.8336 13.599C26.8336 13.0531 26.3823 12.6106 25.8255 12.6106C25.2687 12.6106 24.8174 13.0531 24.8174 13.599C24.8174 14.1449 25.2687 14.5875 25.8255 14.5875Z"
                      fill="#10294F"
                    />
                    <path
                      d="M17.0479 24.7615C17.4416 24.3754 18.0796 24.3754 18.4734 24.7615L18.7688 25.0511V16.5645H16.7526V25.0511L17.0479 24.7615Z"
                      fill="#10294F"
                    />
                    <path
                      d="M27.8418 16.5645H20.785V27.4372C20.785 27.8368 20.5399 28.1979 20.1628 28.3503C20.0378 28.4015 19.9068 28.4257 19.7769 28.4257C19.5151 28.4257 19.2571 28.3253 19.0642 28.136L17.7607 26.858L16.4572 28.136C16.1677 28.4199 15.7365 28.5038 15.3585 28.3503C14.9815 28.1979 14.7363 27.8368 14.7363 27.4372V16.5645H14.1711L6.67151 20.8099V33.4337C6.67151 33.9801 7.1224 34.4221 7.67962 34.4221H27.8418C28.399 34.4221 28.8499 33.9801 28.8499 33.4337V17.5529C28.8499 17.0065 28.399 16.5645 27.8418 16.5645Z"
                      fill="#10294F"
                    />
                    <path
                      d="M25.4729 6.74188L23.4569 3.31795C23.323 3.09114 23.1025 2.92508 22.8445 2.85754C22.5876 2.79092 22.311 2.82571 22.0796 2.95598L18.9781 4.71171C18.9806 4.02204 18.8138 3.27419 18.4527 2.66137C17.9142 1.74627 17.045 1.09187 16.0043 0.818663C14.9657 0.547436 13.8778 0.68641 12.9446 1.21344C11.652 1.94607 10.8792 3.30998 10.9303 4.77332L10.9372 4.98181C10.9372 4.98952 10.9372 4.99631 10.9382 5.00402L11.0367 7.92359L8.55091 6.40489C8.5499 6.4039 8.54796 6.40298 8.54695 6.40199L8.36582 6.29096C7.09783 5.51781 5.50885 5.48881 4.2143 6.22144C3.281 6.74946 2.61356 7.60175 2.33492 8.62208C2.05628 9.64241 2.1991 10.708 2.73756 11.6231C3.10552 12.2468 3.62349 12.7317 4.21908 13.0668L1.05994 14.8172C0.577658 15.0903 0.41253 15.6947 0.690902 16.1676L2.77399 19.5918C3.05236 20.0645 3.66885 20.2266 4.15113 19.9536L25.104 8.09215C25.5862 7.81927 25.7513 7.21475 25.4729 6.74188ZM7.23742 11.3581C6.27373 11.9015 5.03894 11.5784 4.48394 10.6347C3.92773 9.69071 4.25947 8.4783 5.22228 7.93393C5.86908 7.56617 6.66555 7.58159 7.29857 7.96866L10.1483 9.71021L7.23742 11.3581ZM16.9081 5.21568C16.7694 5.72485 16.4359 6.15113 15.9699 6.41464L13.0582 8.06296L12.9446 4.70571C12.92 3.97308 13.3069 3.29159 13.9527 2.92574C14.4174 2.66031 14.9608 2.59178 15.4826 2.72785C16.0024 2.86492 16.4375 3.19215 16.7063 3.64967C16.9761 4.10731 17.0479 4.70505 16.9081 5.21568Z"
                      fill="#10294F"
                    />
                  </svg>
                </div>
                <div className="title">{__("Welcome Package")}</div>
                <div className="title dsc">
                  {__(
                    "Get 100% up to 1 BTC on your 1st deposit, 50% up to 0.5 BTC on your 2nd!"
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="single_block">
                <div className="icon">
                  <svg
                    width="36"
                    height="35"
                    viewBox="0 0 36 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1345 0.532959C8.63277 0.532959 0.929932 8.0857 0.929932 17.402C0.929932 26.718 8.63277 34.2717 18.1344 34.2717C27.6361 34.2717 35.3397 26.7184 35.3397 17.402C35.3394 8.0857 27.6363 0.532959 18.1345 0.532959ZM27.9598 19.5188C27.1849 24.3467 22.92 27.8028 18.0841 27.8028C17.5694 27.8028 17.0486 27.7635 16.5244 27.683C11.0765 26.8412 7.34126 21.8108 8.19806 16.4699C8.61338 13.882 10.0315 11.6075 12.1912 10.0657C14.0505 8.73853 16.2674 8.09278 18.5324 8.19804L16.8662 6.64227L17.9583 5.51867L20.5149 7.90722L20.5155 7.90688L21.659 8.97672L20.5679 10.1003L20.5673 10.0994L18.1314 12.6067L16.9867 11.536L18.5301 9.94894C16.6425 9.8439 14.7904 10.3751 13.2417 11.4805C11.4672 12.7473 10.3022 14.6158 9.96098 16.7419C9.25742 21.13 12.3263 25.2628 16.802 25.9541C21.2774 26.6436 25.4921 23.6355 26.1963 19.2468C26.6613 16.3499 25.4823 13.4304 23.1184 11.6275L24.215 10.2464C27.0906 12.4399 28.5257 15.9929 27.9598 19.5188ZM14.8193 20.2634L14.7607 20.1289L16.2315 19.5175L16.2895 19.6523C16.5234 20.1966 17.3319 20.6069 18.1699 20.6069C18.5465 20.6069 19.7751 20.5396 19.7751 19.6691C19.7751 19.2132 19.2498 18.9403 18.1217 18.8098C16.8559 18.6707 15.1209 18.4805 15.1209 16.6071C15.1209 15.4584 15.9974 14.6554 17.4732 14.4416V13.5587H19.0584V14.4455C19.7435 14.5635 20.6476 14.8562 21.1518 15.8674L21.2188 16.0012L19.8649 16.6153L19.7964 16.5036C19.5593 16.1198 18.862 15.8185 18.2097 15.8185C17.7697 15.8185 16.7467 15.8955 16.7467 16.6069C16.7467 17.1183 17.4059 17.236 18.2681 17.3373C19.616 17.5 21.4613 17.7229 21.4613 19.6689C21.4613 21.1011 20.2767 21.855 19.0588 21.9886V22.9955H17.4739V22.037C16.195 21.8896 15.2548 21.2627 14.8193 20.2634Z"
                      fill="#10294F"
                    />
                  </svg>
                </div>
                <div className="title">{__("Cashback")}</div>
                <div className="title dsc">
                  {__(
                    "Finish $250 or more down in any given week? Expect 10% Cashback in your account on the Monday after!"
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3">
              <div className="single_block">
                <div className="icon">
                  <svg
                    width="28"
                    height="33"
                    viewBox="0 0 28 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.0709 2.51785C26.9506 1.8411 26.3515 1.34725 25.6509 1.34725H22.526C22.2815 0.90786 21.8061 0.609619 21.2597 0.609619H5.98674C5.44037 0.609619 4.96486 0.90786 4.72049 1.3473H1.59585C0.895313 1.3473 0.296209 1.84126 0.175856 2.5178C0.158792 2.61391 -0.234054 4.89987 0.517298 7.40734C1.06016 9.2192 2.27352 11.4033 4.96029 12.7652C4.51865 13.8458 3.97706 15.037 3.31315 16.3516C3.17595 16.6232 3.22209 16.9493 3.42941 17.1741C5.46903 19.3845 7.78283 20.8743 10.2446 21.584C10.24 21.6369 10.2364 21.6902 10.2364 21.7442V21.8378C10.2364 22.5527 10.6457 23.1734 11.2467 23.4883C11.3384 24.6361 11.0715 26.5146 10.445 28.0032H7.71968C7.11446 28.0032 6.62391 28.4842 6.62391 29.0776V31.4337C6.62391 32.0271 7.11441 32.508 7.71968 32.508H19.5268C20.132 32.508 20.6226 32.027 20.6226 31.4337V29.0776C20.6226 28.4842 20.1321 28.0032 19.5268 28.0032H16.8014C16.1748 26.5146 15.9076 24.6363 15.9988 23.4886C16.6002 23.1738 17.0096 22.5529 17.0096 21.8378V21.7442C17.0096 21.6902 17.006 21.637 17.0014 21.5841C19.4632 20.8744 21.7771 19.3846 23.8166 17.1741C24.0239 16.9493 24.0701 16.6232 23.9329 16.3516C23.2697 15.0383 22.7271 13.8475 22.284 12.7661C24.972 11.4043 26.1859 9.21972 26.729 7.4074C27.4806 4.89997 27.088 2.61396 27.0709 2.51785ZM3.30869 6.69374C3.01796 5.76394 2.94232 4.85635 2.94061 4.17381H4.7207C4.96513 4.61325 5.44048 4.91128 5.98685 4.91128C6.2393 4.91128 6.47639 4.84728 6.68276 4.73548C6.68419 4.74772 6.68584 4.75956 6.68728 4.77191C6.80997 5.8624 6.71003 7.54593 5.93858 10.0553C4.65176 9.29514 3.7707 8.1715 3.30869 6.69374ZM9.14626 18.1654C8.02572 18.4503 6.82251 17.4662 6.20411 16.662C6.05266 16.4651 5.91907 16.2678 5.98483 16.0085C6.02337 15.8563 6.13458 15.7301 6.22155 15.6016C6.60105 15.0401 6.91559 14.4318 7.19223 13.816C7.77225 12.5252 8.21172 11.1782 8.53775 9.80479C8.78377 8.76845 8.94192 7.72086 9.14626 6.6766C9.42965 8.40157 9.35863 10.1859 9.00943 11.8958C8.87478 12.5554 8.69186 13.2038 8.46497 13.8383C8.18259 14.6282 7.83296 15.458 7.35081 16.1681C7.85162 16.9111 8.42574 17.6279 9.14626 18.1654ZM23.9378 6.69369C23.4751 8.1728 22.5927 9.29738 21.3039 10.0577C20.535 7.56439 20.4258 5.86793 20.5643 4.73589C20.7705 4.84759 21.0074 4.91133 21.2596 4.91133C21.806 4.91133 22.2814 4.6132 22.5257 4.17386H24.306C24.3043 4.85692 24.2286 5.7642 23.9378 6.69369Z"
                      fill="#10294F"
                    />
                  </svg>
                </div>
                <div className="title">{__("Races")}</div>
                <div className="title dsc">
                  {__(
                    "Regular Races giving you the chance to share huge prize pools just for playing your favourite games!"
                  )}
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
        </div>
      </section>

      <div className="black_bg_area">
        <div className="container-fluid">
          <section className="deposit_quick_section">
            <div className="row">
              <div className="col-lg-6">
                <br />
                <br />
                <br />
                <br />
                <div className="title">
                  {__("Deposit quickly and easily with a")} <br />
                  {__("huge range of Crypto currencies")}
                </div>
                <br />
                <br />
                <div className="title dsc">
                  {__(
                    "Fast deposits and cashouts using BTC, ETH, LTC, DOGE, USDTE, USDTT, TRX & XRP with more Coins coming soon – use your Credit/Debit Card or Bank directly if you prefer!"
                  )}
                </div>
                <br />
                <br />
                <Link
                  className="app_btn"
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                >
                  {__("join now")}
                </Link>
                <br />
                <br />
                <br />
                <br />
              </div>
              <div className="col-lg-6">
                <div className="area_image">
                  <img
                    src={
                      require("../assets/images/new-design/deposit-coin-bg.svg")
                        .default
                    }
                  />
                </div>
                <br />
                <br />
              </div>
            </div>
          </section>
        </div>
        <section className="blitz_the_game">
          <div className="container-md">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <br />
                <br />
                <br />

                <div className="title">
                  {__("Blitz the Games and win at Blizz")}
                </div>
                <br />

                <div className="title dsc">
                  {__(
                    "Whatever your choice of game, we have something for you. A huge range of slots from all the top providers including Netent, Microgaming, Pragmatic Play and more, Live Casino games including Blackjack, Roulette, Baccarat and Game Shows with Evolution, life changing Progressive Jackpot Slots and plenty more, with new games added every week! Once you play at Blizz, you won’t want to play online slots or online casino games anywhere else!"
                  )}
                </div>
                <br />
                <br />
                <br />

                <Link
                  className="app_btn margin_0_auto"
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                >
                  {__("GET STARTED")}
                </Link>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </section>
        <div className="container-fluid">
          <section className="deposit_quick_section try">
            <div className="row">
              <div className="col-lg-5">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <div className="title">{__("Try before you buy!")}</div>
                <br />
                <br />
                <div className="title dsc">
                  {__(
                    "Not sure which of our huge games to play? Try most games out for free before spending your hard earned coins – we even have a section for Bonus Buys where you can pay extra to activate a bonus straight away!"
                  )}
                </div>
                <br />
                <br />
                <Link
                  className="app_btn no_active"
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                >
                  {__("TRY NOW")}
                </Link>
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
              <div className="col-lg-7">
                <div className="area_image">
                  <img
                    className="height_800"
                    src={
                      require("../assets/images/new-design/try-bg.svg").default
                    }
                  />
                </div>
                <br />
                <br />
              </div>
            </div>
          </section>
        </div>
        <section className="deposit_quick_section deposit_widtdraw padding_left_0 padding_right_70">
          <div className="row">
            <div className="col-lg-5">
              <div className="area_image">
                <img
                  className="no_position"
                  src={
                    require("../assets/images/new-design/deposit-withdraw.svg")
                      .default
                  }
                />
              </div>
              <br />
              <br />
            </div>
            <div className="col-lg-7">
              <br />
              <br />
              <br />
              <br />
              <div className="title">
                {__("Deposit and Withdraw funds fast")}
              </div>
              <br />
              <br />
              <div className="title dsc">
                {__(
                  "With our easy to use cashier, you will find adding and withdrawing from your account is a piece of cake meaning you can get your funds and do you want with them quickly – we even have a wallet within a wallet – the Vault – saving you even more time! Open an account today in just 2 minutes!"
                )}
              </div>
              <br />
              <br />
              <Link
                className="app_btn no_active white"
                onClick={() => {
                  props.setModalSignUpPropsData(true);
                  setTimeout(function () {
                    props.setModalSignUpPropsData(false);
                  }, 500);
                }}
              >
                {__("JOIN NOW")}
              </Link>
            </div>
            <br />
            <br />
            <br />
          </div>
          <br />
          <br />
          <br />
        </section>

        <section className="welcome_section">
          <div className="container-md">
            <div className="welcome_img">
              <img
                src={
                  require("../assets/images/new-design/wellcome-bg.svg").default
                }
              />
            </div>
            <br />
            <br />
            <br />
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4">
                <div className="single_block height_290">
                  <div className="icon">
                    <svg
                      width="34"
                      height="35"
                      viewBox="0 0 34 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.689 10.6867C10.2418 10.6867 11.6095 10.2727 12.739 9.74452C11.5923 11.8515 10.9053 14.2904 10.7689 16.8056C6.18413 17.2862 2.589 21.0425 2.589 25.6455C2.589 30.5727 6.69352 34.6472 11.739 34.6472C13.2934 34.6472 14.7824 34.2195 16.1178 33.5041C14.0461 31.5208 12.7557 28.6958 12.7557 25.6455C12.7557 22.5951 14.0461 19.8363 16.1178 17.853C15.0895 17.302 13.969 16.9273 12.7991 16.7818C13.2412 9.76417 18.6682 3.97572 25.6655 2.91953C23.8834 5.36285 22.9223 8.27828 22.9223 11.3393V16.8102C18.3598 17.3116 14.789 21.058 14.789 25.6455C14.789 30.5727 18.8935 34.6472 23.939 34.6472C28.9845 34.6472 33.089 30.5727 33.089 25.6455C33.089 21.058 29.5182 17.3116 24.9557 16.8102V11.3393C24.9557 7.98249 26.294 4.82661 28.7245 2.45311L30.46 0.758301H28.0057C23.2305 0.758301 18.9028 2.65995 15.7715 5.72741C14.9494 4.95666 12.3135 2.74398 8.689 2.74398C4.39993 2.74398 1.4651 5.86496 1.32319 5.99785L0.555664 6.71533L1.32319 7.43281C1.4651 7.56571 4.39993 10.6867 8.689 10.6867ZM23.939 22.6669C22.2573 22.6669 20.889 24.0031 20.889 25.6455H18.8557C18.8557 22.9084 21.1363 20.6813 23.939 20.6813V22.6669ZM11.739 22.6669C10.0573 22.6669 8.689 24.0031 8.689 25.6455H6.65566C6.65566 22.9084 8.93628 20.6813 11.739 20.6813V22.6669Z"
                        fill="#10294F"
                      />
                    </svg>
                  </div>
                  <div className="title">{__("Best choice of games")}</div>
                  <div className="title dsc">
                    {__(
                      "We have one of the largest range of games of any Crypto Casino meaning you will always be able to find an online casino game to suit your mood – you really won’t want to play anywhere else after you have played at Blizz!"
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="single_block height_290">
                  <div className="icon">
                    <svg
                      width="35"
                      height="35"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M33.9576 12.6107H32.9494V11.6222C32.9494 11.0759 32.4985 10.6338 31.9413 10.6338C31.3841 10.6338 30.9332 11.0759 30.9332 11.6222V12.6107H29.9251C29.3679 12.6107 28.917 13.0528 28.917 13.5991C28.917 14.1455 29.3679 14.5875 29.9251 14.5875H30.9332V15.576C30.9332 16.1223 31.3841 16.5644 31.9413 16.5644C32.4985 16.5644 32.9494 16.1223 32.9494 15.576V14.5875H33.9576C34.5148 14.5875 34.9657 14.1455 34.9657 13.5991C34.9657 13.0528 34.5148 12.6107 33.9576 12.6107Z"
                        fill="#10294F"
                      />
                      <path
                        d="M29.858 8.65681C30.4147 8.65681 30.8661 8.21427 30.8661 7.66837C30.8661 7.12247 30.4147 6.67993 29.858 6.67993C29.3012 6.67993 28.8499 7.12247 28.8499 7.66837C28.8499 8.21427 29.3012 8.65681 29.858 8.65681Z"
                        fill="#10294F"
                      />
                      <path
                        d="M25.8255 14.5875C26.3823 14.5875 26.8336 14.1449 26.8336 13.599C26.8336 13.0531 26.3823 12.6106 25.8255 12.6106C25.2687 12.6106 24.8174 13.0531 24.8174 13.599C24.8174 14.1449 25.2687 14.5875 25.8255 14.5875Z"
                        fill="#10294F"
                      />
                      <path
                        d="M17.0479 24.7615C17.4416 24.3754 18.0796 24.3754 18.4734 24.7615L18.7688 25.0511V16.5645H16.7526V25.0511L17.0479 24.7615Z"
                        fill="#10294F"
                      />
                      <path
                        d="M27.8418 16.5645H20.785V27.4372C20.785 27.8368 20.5399 28.1979 20.1628 28.3503C20.0378 28.4015 19.9068 28.4257 19.7769 28.4257C19.5151 28.4257 19.2571 28.3253 19.0642 28.136L17.7607 26.858L16.4572 28.136C16.1677 28.4199 15.7365 28.5038 15.3585 28.3503C14.9815 28.1979 14.7363 27.8368 14.7363 27.4372V16.5645H14.1711L6.67151 20.8099V33.4337C6.67151 33.9801 7.1224 34.4221 7.67962 34.4221H27.8418C28.399 34.4221 28.8499 33.9801 28.8499 33.4337V17.5529C28.8499 17.0065 28.399 16.5645 27.8418 16.5645Z"
                        fill="#10294F"
                      />
                      <path
                        d="M25.4729 6.74188L23.4569 3.31795C23.323 3.09114 23.1025 2.92508 22.8445 2.85754C22.5876 2.79092 22.311 2.82571 22.0796 2.95598L18.9781 4.71171C18.9806 4.02204 18.8138 3.27419 18.4527 2.66137C17.9142 1.74627 17.045 1.09187 16.0043 0.818663C14.9657 0.547436 13.8778 0.68641 12.9446 1.21344C11.652 1.94607 10.8792 3.30998 10.9303 4.77332L10.9372 4.98181C10.9372 4.98952 10.9372 4.99631 10.9382 5.00402L11.0367 7.92359L8.55091 6.40489C8.5499 6.4039 8.54796 6.40298 8.54695 6.40199L8.36582 6.29096C7.09783 5.51781 5.50885 5.48881 4.2143 6.22144C3.281 6.74946 2.61356 7.60175 2.33492 8.62208C2.05628 9.64241 2.1991 10.708 2.73756 11.6231C3.10552 12.2468 3.62349 12.7317 4.21908 13.0668L1.05994 14.8172C0.577658 15.0903 0.41253 15.6947 0.690902 16.1676L2.77399 19.5918C3.05236 20.0645 3.66885 20.2266 4.15113 19.9536L25.104 8.09215C25.5862 7.81927 25.7513 7.21475 25.4729 6.74188ZM7.23742 11.3581C6.27373 11.9015 5.03894 11.5784 4.48394 10.6347C3.92773 9.69071 4.25947 8.4783 5.22228 7.93393C5.86908 7.56617 6.66555 7.58159 7.29857 7.96866L10.1483 9.71021L7.23742 11.3581ZM16.9081 5.21568C16.7694 5.72485 16.4359 6.15113 15.9699 6.41464L13.0582 8.06296L12.9446 4.70571C12.92 3.97308 13.3069 3.29159 13.9527 2.92574C14.4174 2.66031 14.9608 2.59178 15.4826 2.72785C16.0024 2.86492 16.4375 3.19215 16.7063 3.64967C16.9761 4.10731 17.0479 4.70505 16.9081 5.21568Z"
                        fill="#10294F"
                      />
                    </svg>
                  </div>
                  <div className="title">{__("Promotions")}</div>
                  <div className="title dsc">
                    {__(
                      "Get 2 Welcome Bonuses, Weekly Cashback, Races with huge Prize Pools, Loyalty & VIP Scheme, Reloads and plenty more when you play at Blizz!"
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <div className="single_block height_290">
                  <div className="icon">
                    <svg
                      width="34"
                      height="33"
                      viewBox="0 0 34 33"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.808 0.720215C7.82422 0.72784 0.54765 7.87468 0.555426 16.6832C0.563203 25.4918 7.8523 32.6263 16.8362 32.6186C25.8145 32.611 33.0888 25.4726 33.0888 16.6695C33.0733 7.86183 25.791 0.727775 16.808 0.720215ZM23.4863 15.0841L23.4722 15.0979L17.1455 26.3189C17.0298 26.5329 16.8021 26.6659 16.555 26.6635H16.3582C16.0613 26.5703 15.8653 26.2933 15.8802 25.988L16.2036 19.3023H10.7204C10.4857 19.2998 10.2685 19.1803 10.1439 18.9852C10.0204 18.7813 10.0204 18.5275 10.1439 18.3235L16.4707 7.01986C16.6228 6.74356 16.949 6.60651 17.258 6.68903C17.5519 6.78614 17.7461 7.06057 17.736 7.36447L17.4267 14.0503H22.9098C23.1527 14.0499 23.3753 14.183 23.4863 14.3949C23.6323 14.6024 23.6323 14.8767 23.4863 15.0841Z"
                        fill="#10294F"
                      />
                    </svg>
                  </div>
                  <div className="title">{__("Quick Transactions")}</div>
                  <div className="title dsc">
                    {__(
                      "Deposit and Withdraw quickly with a huge range of Crypto Currencies or use your Credit/Debit Card or Bank Account to purchase Crypto and start playing – only at Blizz!"
                    )}
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
          </div>
        </section>
      </div>
    </div>
  );
}
